import { useCategoriesQuery } from 'hooks/useCategoriesQuery'
import { Media } from 'media'
import { ComponentType } from 'react'
import { RoleModel } from 'utils/role'
import { CategoriesDesktop } from './categories-desktop'
import { CategoriesMobile } from './categories-mobile'

interface Props {
  role: RoleModel
}

export const Categories: ComponentType<Props> = ({ role }) => {
  const { data } = useCategoriesQuery({ variables: { query: { role: role.query } } })

  const categories = data?.categories.data ?? []

  return (
    <>
      <Media at="xs">
        <CategoriesMobile categories={categories} role={role} />
      </Media>
      <Media greaterThan="xs">
        <CategoriesDesktop categories={categories} role={role} />
      </Media>
    </>
  )
}
